import BkButton from '../../Components/ui/BkButton';
import BkPanel from '../../Components/ui/BkPanel';
import usePageMeta from '../../hooks/use-page-meta';
import MatchReveal from './MatchReveal';
import useQueue from './hooks/use-queue';

function formatElapsed(sec: number) {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export default function Queue() {
  usePageMeta({
    title: 'Matchmaking',
    description: 'Finding an opponent for Blind Kings.',
    path: '/queue',
    noindex: true,
  });

  const { modeLabel, status, elapsedSec, cancelQueue, reveal } = useQueue();

  if (reveal) {
    return (
      <MatchReveal
        modeLabel={modeLabel}
        you={reveal.you}
        opponent={reveal.opponent}
        secondsLeft={reveal.secondsLeft}
      />
    );
  }

  return (
    <div className="flex min-h-full flex-col items-center justify-center px-4 py-12">
      <BkPanel className="w-full max-w-lg space-y-8 text-center">
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bk-gold-dim">
            Matchmaking
          </p>
          <h1 className="text-3xl font-extrabold uppercase tracking-wider text-bk-text sm:text-4xl">
            {modeLabel}
          </h1>
        </div>

        <div className="flex flex-col items-center gap-3">
          <div className="h-12 w-12 animate-spin rounded-full border-2 border-bk-gold-dim border-t-bk-gold" />
          <p className="animate-bk-pulse-soft text-lg font-semibold uppercase tracking-wider text-bk-gold">
            Searching for opponent
          </p>
          <p className="font-mono text-sm text-bk-muted tabular-nums">
            {formatElapsed(elapsedSec)}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 border-t border-bk-gold-dim/30 pt-6">
          <div>
            <div className="text-2xl font-bold text-bk-gold-bright tabular-nums">
              {status.onlineCount ?? 0}
            </div>
            <div className="text-xs uppercase tracking-wider text-bk-muted">
              Players online
            </div>
          </div>
          <div>
            <div className="text-2xl font-bold text-bk-gold-bright tabular-nums">
              {status.gamesInProgress ?? 0}
            </div>
            <div className="text-xs uppercase tracking-wider text-bk-muted">
              Games in progress
            </div>
          </div>
        </div>

        <BkButton variant="secondary" size="md" onClick={() => void cancelQueue()}>
          Cancel
        </BkButton>
      </BkPanel>
    </div>
  );
}
